<form #newModule="ngForm" (ngSubmit)="createupdatemodule()" class="mb-0">  
  <div class="restrict-img-width mw-100 mx-auto mb-3">
    <div *ngIf="logoimg.style.display === 'none'"
      class="img-placeholder rounded shadow-sm-darker d-flex align-items-center justify-content-center text-xs"
      [style]="'height:' + settings.moduleImageHeight + 'px'">No Image Added</div>
    <img #logoimg src="{{module.logo}}" alt="Image to be uploaded"
      class="w-100 bg-black-100 object-cover object-center rounded shadow-sm-darker" style="display: none;">
    <div class="text-center">
      <button (click)="logo.click()" type="button" id="courseHeaderImgLabel"
        class="btn mx-auto mt-2 mb-1"><i class="fa fa-plus"></i> Add Header Image</button>
      <input #logo (change)="handleLogoFileChange($event.target.files)" type="file" name="logo" accept="image/*"
        aria-labelledby="courseHeaderImgLabel" id="courseHeaderImg" class="sr-only">
      <!-- <span class="text-xs">{{settings.moduleImageWidth}} x {{settings.moduleImageHeight}} pixels required</span> -->
    </div>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="schoolname">Course Name <span class="requiredfield">*</span></label>
    <input type="text" [(ngModel)]="module.name" #name name="name" maxlength="200" required class="text-field"
      id="schoolname">
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="code">Course Code</label>
    <input type="text" [(ngModel)]="module.courseCode" #courseCode name="courseCode" class="text-field" id="code">
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="allowBatches"> Batch Students </label>
     <select class="text-field" [(ngModel)]="module.allowBatches"
      #allowBatches name="allowBatches"
      id="allowBatches">
      <option [ngValue]="true" selected>
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Date of availability"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">Teach your course in batches to make sure all your students start and end the course together. Extremely useful when you intend to teach your students in live classes</p>
    </div>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="accessDays">Pass Score (%) </label>
    <input type="number" [(ngModel)]="module.passScorePercentage" #passScorePercentage name="passScorePercentage"
      class="text-field" id="accessDays" (change)="this.accessDaysChanged = true;">
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="price">Price</label>
    <input type="number" [(ngModel)]="module.price" #price name="price" class="text-field" id="price">
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="accessDays">Access Days </label>
    <input type="number" [(ngModel)]="module.accessdays" #accessdays name="accessdays" class="text-field"
      id="accessDays" (change)="this.accessDaysChanged = true;">
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="reqEnroll">Require Enrollment</label>
    <select class="text-field" [(ngModel)]="module.requireEnrollment" #requireEnrollment name="requireEnrollment"
      id="reqEnroll" [disabled]="module.price">
      <option [ngValue]="true" selected>
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="reqEnroll">Require Student to complete a Lesson before Moving to the next one</label>
    <select class="text-field" [(ngModel)]="module.requireLessonCompletion" #requireLessonCompletion
      name="requireLessonCompletion" id="reqCompletion">
      <option [ngValue]="true" selected>
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="publishDate">Publish Date</label>
    <input [owlDateTime]="rawpublisheddatetime"  class="text-field" id="publishDate" name="publishDate"
      #publishDate  [(ngModel)]="module.publishDate">
    <button type="button" [owlDateTimeTrigger]="rawpublisheddatetime"
      class="owlDateTimeTrigger position-absolute right-4 top-0 bottom-0 m-auto d-flex align-items-center px-3 bg-transparent border-0 text-body"
      title="Calendar">
      <i class="fa fa-calendar"></i>
    </button>
    <owl-date-time #rawpublisheddatetime></owl-date-time>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Date of availability"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">This is the date from which the course will be made available</p>
    </div>
    
  </div>

  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="sendCertificateOnCompletion"> Generate Certificate On Completion </label>
    <select class="text-field" [(ngModel)]="module.sendCertificateOnCompletion" #sendCertificateOnCompletion
      name="sendCertificateOnCompletion" id="sendCertificateOnCompletion">
      <option [ngValue]="true" selected>
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="retakemultiplechoice"> Allow Retake for Multiple Choice Assessment </label>
    <select class="text-field" [(ngModel)]="module.retakemultiplechoice" #retakemultiplechoice
      name="retakemultiplechoice" id="retakemultiplechoice">
      <option [ngValue]="true">
        Yes
      </option>
      <option [ngValue]="false" selected>
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="userCompleteCourseWhenAllLessonsAreCompleted"> User Can Complete Course When All Lessons
      Are Completed </label>
    <select class="text-field" [(ngModel)]="module.userCompleteCourseWhenAllLessonsAreCompleted"
      #userCompleteCourseWhenAllLessonsAreCompleted name="userCompleteCourseWhenAllLessonsAreCompleted"
      id="userCompleteCourseWhenAllLessonsAreCompleted">
      <option [ngValue]="true" selected>
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend z-1" for="sendMarkedNotification">Send Notification to User when Assessments are Graded</label>
    <select class="text-field" [(ngModel)]="module.sendMarkedNotification"
      #sendMarkedNotification name="sendMarkedNotification" id="sendMarkedNotification">
      <option [ngValue]="true" selected>
        Yes
      </option>
      <option [ngValue]="false">
        No
      </option>
    </select>
  </div>

  <div class="fieldset fieldset--note">
    <label class="legend z-1">Course Description <span class="requiredfield">*</span></label>
    <quill-editor required #description name="description" placeholder="Enter Description of Course"></quill-editor>
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button class="btn m-0" [disabled]="!newModule.form.valid" type="submit"> Save </button>
    <button class="btn btn--warning m-0" *ngIf="!moduleid && schoolid" routerLink="/user/schoolhome"> Cancel </button>
    <button class="btn btn--warning m-0" *ngIf="moduleid" routerLink="/user/moduledetails"
      [queryParams]="{moduleID: module.id}"> Cancel </button>
  </div>
</form>

<div *ngIf="this.moduleid" class="modal fade" #mediaModal tabindex="-1" role="dialog" aria-labelledby="mediaModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="mediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-module-media-library [moduleid]="this.moduleid" [enableselect]="true"
          (mediaSelected)="mediaSelected($event)"></app-module-media-library>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn--warning" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" #externalMediaModal tabindex="-1" role="dialog" aria-labelledby="externalMediaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="externalMediaModalLabel">Select Media</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-add-external-media #addExternalMediaComponent></app-add-external-media>
      </div>      
      <div class="modal-footer justify-content-center gap-1.5">
        <button type="button" class="btn m-0" (click)="externalMediaSelected()"
          [disabled]="!addExternalMediaComponent.mediaurl.trim()">Ok</button>
        <button type="button" class="btn btn--warning m-0" (click)="closeExternalMediaModal()">Close</button>
      </div>
    </div>
  </div>
</div>
